import { ThemeButtonKeys } from '../../../styles/tokens/buttons';
import { ThemeColorsKeys } from '../../../styles/tokens/colors';

interface Tokens {
  logOutButtonVariant: ThemeButtonKeys;
  contactIconColor: ThemeColorsKeys;
  enableCallToActionButton: boolean;
  enableSearch: boolean;
  hoverColour: ThemeColorsKeys;
}

const tokens: Tokens = {
  logOutButtonVariant: 'secondaryOutline',
  contactIconColor: 'brandOne100',
  enableCallToActionButton: true,
  enableSearch: true,
  hoverColour: 'brandOne',
} as const;

export default tokens;
